import {axios} from "./axios"
import qs from 'qs'
const getMerchantServeInfo =(data)=>{
    return  axios({
        method:"post",
        url:"/api/merchantServeInfo/getMerchantServeInfo",
        data:qs.stringify(data)
    })
}
export {getMerchantServeInfo}